/**
 * Sticky Add-to-Cart Bar
 * Self-contained: reads product info from the DOM, no Liquid needed.
 * Only activates on product pages (pages with [data-add-to-cart] button).
 */
(function () {
  'use strict';

  /* ── Only run on product pages ── */
  var mainBtn = document.querySelector('product-info [data-add-to-cart]')
    || document.querySelector('[data-product-form] [data-add-to-cart]');
  if (!mainBtn) return;

  /* ── Read product info from the existing DOM ── */
  var titleEl = document.querySelector('.product__title');
  var priceEl = document.querySelector('[data-product-price]');

  var title = titleEl ? titleEl.textContent.trim() : '';
  if (title.length > 42) title = title.substring(0, 39) + '…';

  var price = priceEl ? priceEl.textContent.trim() : '';

  /* ── Build the bar ── */
  var bar = document.createElement('div');
  bar.className = 'sticky-atc-bar';
  bar.innerHTML =
    '<div class="sticky-atc-bar__info">' +
      '<div class="sticky-atc-bar__title">' + title + '</div>' +
      '<div class="sticky-atc-bar__price">' + price + '</div>' +
    '</div>' +
    '<button type="button" class="sticky-atc-bar__btn">AÑADIR AL CARRITO</button>';

  document.body.appendChild(bar);

  /* ── Button click → trigger the real ATC ── */
  var stickyBtn = bar.querySelector('.sticky-atc-bar__btn');
  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    mainBtn.click();
  });

  /* ── Show / hide on scroll ── */
  var ticking = false;

  function check() {
    var rect = mainBtn.getBoundingClientRect();
    var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('is-visible', outOfView);
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        check();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', check, { passive: true });

  /* ── Sync price on variant change ── */
  function syncPrice() {
    var p = document.querySelector('[data-product-price]');
    if (p) {
      bar.querySelector('.sticky-atc-bar__price').textContent = p.textContent.trim();
    }
  }

  // Theme dispatches 'variant-change'; also listen for theme:variant:change
  document.addEventListener('variant-change', syncPrice);
  document.addEventListener('theme:variant:change', syncPrice);

  // Also observe the price element for text mutations (covers all themes)
  if (priceEl) {
    var observer = new MutationObserver(syncPrice);
    observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  /* Initial check */
  check();
})();
